import {
  KeywordContainer,
  KeywordRow,
  KeywordText,
  KeywordTextProps,
} from './styles';

interface IKeywordProps {
  children: React.ReactNode;
}

interface IKeywordTextProps extends KeywordTextProps {
  children: React.ReactNode;
  style?: React.CSSProperties | undefined;
}

export const AKeywordContainer: React.FC<IKeywordProps> = ({
  children,
  ...res
}) => <KeywordContainer {...res}>{children}</KeywordContainer>;

export const AKeywordRow: React.FC<IKeywordProps> = ({ children, ...res }) => (
  <KeywordRow {...res}>{children}</KeywordRow>
);

export const AKeywordText: React.FC<IKeywordTextProps> = ({
  children,
  ...res
}) => <KeywordText {...res}>{children}</KeywordText>;
